var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRedRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83134 0.702002L6.26565 1.27429C6.13177 1.40974 6.13177 1.62937 6.26565 1.76484L10.6979 6.24887L0.94276 6.24887C0.753416 6.24887 0.599902 6.40418 0.599902 6.59573L0.599903 7.40508C0.599903 7.59663 0.753416 7.75194 0.94276 7.75194L10.6979 7.75194L6.26565 12.236C6.13177 12.3714 6.13177 12.5911 6.26565 12.7265L6.83134 13.2988C6.96522 13.4343 7.18231 13.4343 7.31622 13.2988L13.2995 7.24566C13.4334 7.11021 13.4334 6.89059 13.2995 6.75511L7.31622 0.701973C7.18234 0.566523 6.96525 0.566523 6.83134 0.702002Z",
    fill: "#DA515E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRedRight);
export default __webpack_public_path__ + "static/media/ArrowRedRight.ecd5f11e66583cb80ca9208f8a5ec8ff.svg";
export { ForwardRef as ReactComponent };